module.exports = __webpack_public_path__ + "img/logout.20d7356d.svg";